import Component from '@glimmer/component';

export default class AppEvent extends Component {}